import React from 'react';

import { Badge, ClockIcon } from '@motorway/mw-highway-code';

import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import { LISTINGS_TABLE_SALE_TYPES } from 'Services/dynamoDb/dynamoDb.const';
import { useCountdownTimer } from 'Utilities/hooks/useCountdownTimer';
import { useGetAdditionalVehicleDetails } from 'Utilities/hooks/vehicle/useGetAdditionalVehicleDetails';

export const BinCountdown: React.FC = () => {
	const vehicle = useVehicleData();
	const { expiryDate } =
		useGetAdditionalVehicleDetails({ id: vehicle.id, saleType: LISTINGS_TABLE_SALE_TYPES.buyItNow }) ?? {};
	const { shouldShowCountdown, timeRemainingText } = useCountdownTimer(expiryDate);
	const shouldShowBadge = shouldShowCountdown && timeRemainingText;

	return shouldShowBadge ? <Badge reverse icon={ClockIcon} text={timeRemainingText} variant="error" /> : null;
};
